import { TicketType } from "@busbud/int-schemas/udm";

import type { TicketTypes } from "@app/types/checkout-types";
import type { NapiV2TripItem } from "@app/types/napi-v2-cart-types";

import { getSegments } from "./segments";

const TICKET_RANKINGS_ORDERED: TicketType[] = [
  TicketType.ETicket,
  TicketType.Print,
  TicketType.Claim,
  TicketType.Voucher,
  TicketType.IDOnly,
  TicketType.SupplierEmail
];

export const orderTicketTypesByRanking = (ticket_types: TicketType[] = []) => {
  const unique_ticket_types = new Set(ticket_types);

  return TICKET_RANKINGS_ORDERED.filter(ticket_type =>
    unique_ticket_types.has(ticket_type)
  );
};

export const getInitialTicketTypes = (
  items: NapiV2TripItem | undefined
): TicketTypes => {
  const ticket_types = {} as TicketTypes;
  if (!items) {
    return ticket_types;
  }
  if (Object.keys(items.ticket_types).length > 0) {
    return items.ticket_types;
  }

  const { segments } = getSegments(items);

  segments.map(segment => {
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    ticket_types[segment.id] = segment.ticket_types[0];
  });

  return ticket_types;
};
